import { Layout, Row, Col } from 'antd'
import PageFooter from 'components/PageFooter'
import PageHeader from 'components/PageHeader'
import PropTypes from 'prop-types'
import { StyledGlobalLayout } from 'components/GlobalStyles'

const { Content } = Layout

export default function Index ({ children, backgroundImage = '/images/bg/auth-bg.png' }) {
  return (
    <Row>
      <Col
        xs={{ span: 0 }}
        md={{ span: 24 }}
      >
        <StyledGlobalLayout bg={backgroundImage}>
          <PageHeader />
          <Content>
            {children({})}
          </Content>
          <PageFooter />
        </StyledGlobalLayout>
      </Col>
      <Col
        xs={{ span: 24 }}
        md={{ span: 0 }}
      >
        <PageHeader />
        {children({})}
        <PageFooter />
      </Col>
    </Row>
  )
}

Index.propTypes = {
  children: PropTypes.any,
  backgroundImage: PropTypes.string
}
